
import { Component, Inject, Input, Output }  from 'ng-metadata/core';
import {LoginService} from '../security/login/login.service';
import {StorageUtil} from '../infra/storageUtil.service';
import {LoginIframeService} from './loginIframe.service';
import {SilentLoginService} from "./silentLogin/silentLogin.service";

@Component({
	selector: 'prm-login-iframe',
	templateUrl: 'components/primoExplore/login-iframe.html',
})

export class LoginIframe{

    private tryAgain : boolean;
    private url : string;
	constructor(  private loginService: LoginService ,private storageUtil: StorageUtil, private loginIframeService:LoginIframeService, private silentLoginService: SilentLoginService ) {
		try {
			if (window.name === 'primo-silent-login') {
				console.log('[prm-login-iframe] skipping inside primo-silent-login frame');
				return;
			}
		} catch (_) {}

		const tryAgainSync = this.loginIframeService.getTryAgain();
		if (tryAgainSync) {
			this.tryAgain = true;
		} else { // trySilentLogin is async
			console.log('[loginIframe.directive] async trySilentLogin() path triggered');
			this.loginIframeService.trySilentLogin().then((result) => {
				this.tryAgain = result;
				console.log('try silent login: '+this.tryAgain);
				if (!result || !this.getUrl()) {
					this.silentLoginService.silentLoginEnd(); // signal that silent login ended
				}
			});
		}
	}


	private getUrl(){
	    this.url = this.loginIframeService.getUrl();
	    return this.url;
    }

    public getLoginUrls(){
	    return this.loginIframeService.getLoginUrls();
    }

    public isSilentIframeEnabled(){
        return this.tryAgain;

    }


}



// WEBPACK FOOTER //
// ./src/main/webapp/components/primoExplore/loginIframe.directive.ts